import { z } from '../zod.js';
import { ObjectIdStringValidationSchema } from '../shared/ObjectId';
import { LivemodeFilterValidationSchema } from '../shared/livemode';

export const GetBookingInputValidationSchema = z.object({
  bookingId: ObjectIdStringValidationSchema.meta({
    description:
      'The ID of the booking to retrieve. Use `list_bookings` first if you need to discover the booking ID by email, name, customer, event, or date range. Payments for checkout pages have their own IDs and are not retrievable here.',
  }),
  livemode: LivemodeFilterValidationSchema,
});
